import { FC } from 'react';

import { DeviceItem, DeviceStatus as ComponentDeviceStatus } from '@gem/components';

import { DeviceStatus, IUserDevice } from 'APP/model/userSettings/userSettingsModel.types';

import { matchPlatformNameToDevicePlatform } from '../../utils/matchPlatformNameToPlatform';

export interface ISessionItemProps {
  session: IUserDevice;
  isOnline?: boolean;
  lastActivityTs?: number;
  onOpenSession?: () => void;
}

const DeviceStatusToComponentDeviceStatusMap: Record<DeviceStatus, ComponentDeviceStatus> = {
  [DeviceStatus.Pending]: ComponentDeviceStatus.Pending,
  [DeviceStatus.Blocked]: ComponentDeviceStatus.Blocked,
  [DeviceStatus.Unlocked]: ComponentDeviceStatus.Unlocked,
  [DeviceStatus.Deleted]: ComponentDeviceStatus.Deleted,
  [DeviceStatus.Trusted]: ComponentDeviceStatus.Trusted,
};

export const SessionItem: FC<ISessionItemProps> = (props) => {
  const { session, isOnline, lastActivityTs, onOpenSession } = props;

  const device = {
    ...session,
    platform: matchPlatformNameToDevicePlatform(session.platform),
    status: props.session.status
      ? DeviceStatusToComponentDeviceStatusMap[props.session.status]
      : undefined,
  };

  return (
    <DeviceItem
      device={device}
      deviceSession={{
        lastActivityTs,
        isOnline,
      }}
      onClick={onOpenSession}
      projectName={PROJECT_CONFIG.projectName}
    />
  );
};
